import React, { Component, Fragment } from "react";
import FlexText from "../../flexText";
import Links from "./links";

class BoxLinks extends Component {
  render() {
    return (
      <Fragment>
        <div
          className="aosHeader"
          style={{
            ...this.props.style,
            backgroundColor: this.props.data.blockStyle.attributes.field_color_1
          }}
        >
          <FlexText
            container="aosHeader"
            max="32"
            min="24"
            pert=".05"
            classes="flexText"
            tag="h2"
            color={
              this.props.data.blockStyle.attributes.field_heading_color_font[0]
                .field_color_1
            }
            styles={{
              marginRight: "25px",
              fontFamily: this.props.data.blockStyle.attributes
                .field_heading_color_font[0].field_font_1.name,
              lineHeight: window.innerWidth > 599 ? "40px" : "30px",
              textShadow: "rgba(0, 0, 0, 0.6) 2px 2px 8px",
              display: "block"
            }}
          >
            {this.props.data.media[0].field_text_1}
          </FlexText>
        </div>
        <Links links={this.props.data.links} nid={this.props.data.nid} />
      </Fragment>
    );
  }
}

export default BoxLinks;
